/* eslint-disable */ // cant worry about it rn

import { useEffect, useState } from "react";
import { sendPostReq } from "../Scripts/misc";

import "../Styles/loginPage.css"
import { useSearchParams } from "react-router-dom";
import PORGLogo from "../Components/PORGLogo";
import { useFormHandler } from "../Scripts/hooks/useFormHandler";

interface Props {
  enter: Function
}

function LoginPage({enter}: Props) {

  const [searchParams, setSearchParams] = useSearchParams();

  let [err, setErr] = useState("")

  const login = async (email: string) => {
    const res = await sendPostReq("/api/login", {email: email}, setErr)

    console.log(res)

    if (res.data.token) {enter(res.data.token)} else {
      switch(res.data) {
        case "unknownUser":
          setErr("Tento uživatel neexistuje. Zkuste prosím jiný email")
          break
        case "timeout":
          setErr("Pohybuješ se po stránce moc rychle.\n Jdi si udělat čaj a za chvíli se vrať")
          break
        default:
          setErr("Na Váš email se poslal přihlašovací odkaz")
      }
    }
  }

  
  let {formData, formChange} = useFormHandler({
    email: ""
  }, () => {login(formData.email)}, false)

  useEffect(() => {
    if (searchParams.get("token")) {enter(searchParams.get("token")); searchParams.delete("token");setSearchParams(searchParams)}
  }, [])

  return (
    <div className="container center-align login-page-container">
      <PORGLogo/>
      <div className="login-container">
        <h1>Přihlásit se</h1>

          <div className="form-group">
            <label htmlFor="username">Email</label>
            <input
              type="email"
              className="form-control"
              id="email"
              placeholder="Email"

              onChange={formChange}
            />
          </div>

          <p>{err}</p>

          <button type="submit" className="btn btn-primary btn-primary-custom" onClick={() => {login(formData.email)}}>
            Přihlásit se
          </button>

          <div className="center-align">
          <hr></hr>
          </div>

          <button type="button" className="btn btn-info msTeams" onClick={() => {window.location.replace("https://prihlasovani.novyp.org/api/MSSAMLLogin")}}><i className="bi bi-microsoft-teams" style={{margin: "5px"}}/>Přihlásit skrz Microsoft Teams</button>
          
      </div>
      </div>
  );
}

export default LoginPage;
